module.exports = __webpack_public_path__ + "img/sdtps-logo-sm.deef50fe.png";